module.exports = __webpack_public_path__ + "static/media/25UNHCR4.13942486.jpg";